import { useFormikContext } from 'formik';
import { getNextApiRoute, handleSetPhoneNumber } from '@libs/common-next';
import { Grid, TextField } from '@petsmart-ui/sparky';
import type { PaymentFormInterface } from '../PaymentForm/types';
import { AddressForm } from '../AddressForm';
import { NameFields } from '../NameFields';
import { CountryTarget } from '../../constants';

export function BillingAddressForm() {
    const { values, touched, errors, handleChange, handleBlur, setFieldValue } =
        useFormikContext<PaymentFormInterface>();

    return (
        <div className="billing-address-form" data-testid="billing-address-form">
            <Grid gap="sm">
                <NameFields
                    values={values}
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    onChange={handleChange}
                />
                <Grid.Item>
                    <AddressForm
                        countryTarget={CountryTarget.BOTH}
                        addressSuggestionRoute={getNextApiRoute('address/suggest-address')}
                    />
                </Grid.Item>
                <Grid.Item>
                    <TextField
                        data-cs-mask
                        data-testid="phone"
                        id="phone"
                        label="Phone number"
                        name="phone"
                        maxLength={14}
                        type="tel"
                        value={values.phone}
                        onBlur={handleBlur}
                        onChange={e => {
                            handleSetPhoneNumber(e, setFieldValue);
                        }}
                        isError={touched.phone && !!errors.phone}
                        fieldNote={touched.phone && errors.phone?.[0]}
                    />
                </Grid.Item>
            </Grid>
        </div>
    );
}
